import { useState } from 'react';
import { eye, eyeOff } from 'ionicons/icons';

export const usePasswordView = () => {

    const iconsView = {
        'true': eyeOff,
        'false': eye
    };

    const [iconEye, setIconEye] = useState({

        icon: iconsView['false'],
        showPassword: false
    });

    const handleShowPassword = () => {

        setIconEye({

            icon: iconsView[(!iconEye.showPassword).toString()],
            showPassword: !iconEye.showPassword
        });
    };

    return {

        iconEye,
        handleShowPassword,
        setIconEye,
    };
}
